/*
 * Copyright (c) 2025, Wultra s.r.o. (www.wultra.com).
 *
 * All rights reserved. This source code can be used only for purposes specified
 * by the given license contract signed by the rightful deputy of Wultra s.r.o.
 * This source code can be used only by the owner of the license.
 *
 * Any disputes arising in respect of this agreement (license) shall be brought
 * before the Municipal Court of Prague.
 */

import type { ViewModel } from "../../viewmodel/viewmodel"

import type { ApplicationService } from "./application-service"
import type { ApplicationStore } from "./application-store"
import type { ApplicationStatus, PageApplicationId, PageApplicationList } from "./application-types"

export class ApplicationViewModel implements ViewModel {
    name: string = this.constructor.name

    constructor(
        private readonly store: ApplicationStore,
        private readonly service: ApplicationService
    ) {}

    get selectedPageId(): PageApplicationId | null {
        return this.store.selectedPageId
    }

    get selectedPageItem(): PageApplicationList | null {
        const key = this.store.selectedPageId
        if (!key) {
            return null
        }
        return this.store.getApplications(key) ?? null
    }

    // Service calls
    async getApplications(
        appTypeId: number,
        status: ApplicationStatus,
        flags: string[] = [],
        page: number = 0
    ): Promise<void> {
        const key = { appTypeId, status, flags, page }

        const cached = this.store.getApplications(key)
        if (cached) {
            this.store.setSelectedPageId(key)
            return
        }

        const result = await this.service.getApplications(appTypeId, status, flags, page)
        if (result.success && result.data) {
            this.store.setSelectedPageId(key)
        }
    }
}
